import { forceInt, getCurrenLocaleObj } from "../functions";

$(function() {
    const $courseSales = $('.CourseSales');
    if (!$courseSales.length) return;

    const courseSalesId = forceInt($('.js-courseSales').data('id')),
        currenLocaleObj = getCurrenLocaleObj();

    if (courseSalesId) {
        $.get('/data/cs-courses/' + courseSalesId, 'l=' + currenLocaleObj.locale, function(data) {
            // console.log(data);
            if (data && 'courses' in data) {
                // return;
                const courses = data.courses;
                $('.courseSeries__preview').each(function() {
                    const $this = $(this),
                        courseId = $this.data('course-id'),
                        $priceContainer = $this.find('.courseSeries__preview__price'),
                        $priceH4 = $this.find('.courseSeries__preview__price h4'),
                        $buttonsSection = $this.find('.courseSeries__preview__buttons');

                    if ($priceH4.length) {
                        if (courseId in courses) {
                            const course = courses[courseId];
                            let html = '';
                            if (course.salePrice !== '') {
                                html += `<span class="old-price">${course.price}</span>
                                    <span class="new-price">${course.salePrice}</span>`;
                            } else {
                                html += course.price;
                            }
                            if (html !== '') $priceH4.html(html);

                            let owned = false;
                            if (gtmMemberData) {
                                if (gtmMemberData.subscription === 'VIP') {
                                    $priceContainer.hide();
                                }

                                owned = gtmMemberCourses.find(data => forceInt(data.course_id) === forceInt(course.id));
                                if (owned) {
                                    $priceH4.html(`${hpaTranslatedtext.courseSales.courseEntry.ownedCoursePriceText} <span class="glyphicon glyphicon-ok" style="color: #70AE6E;"></span>`);
                                    const $enrollBtn = $this.find('.js-ga_clickIntoCourseEntry');
                                    if ($enrollBtn.length) {
                                        const dashboardlink = $enrollBtn.data('dashboard-link');
                                        $buttonsSection.html(`<a class="btn btn-primary courseSeries__preview__bottom__full_btn" href="${dashboardlink}">${hpaTranslatedtext.courseSales.courseEntry.ownedCourseButton}</a>`);
                                    }
                                }
                            }

                        }
                    }
                });
            }
        }, 'json');
    }
});



// WEBPACK FOOTER //
// ./js/modules/courseSales.js